import bleDeviceConnectionStatus from "../../consts/bleDeviceConnectionStatus";
import Button from "../../components/Buttons/Button";
import useDeviceConnection from "./hooks/useDeviceActions";
import { useDispatch, useSelector } from "react-redux";
import { setDeviceInfo, getDeviceConnectionStatusById, getDeviceInfoById} from "../../state/ducks/ble/bleService";
import deviceService from "../../services/device/deviceService";
import { useDeviceConnectionStatus } from "../../hooks/useDeviceConnectionStatus";
import { useEffect } from "react";
import { isFirmwareVersionGreaterOrEqual } from "../../utils/utils";
import DevicePingService from "../../services/device/devicePingService";
import cn from "classnames";
import styles from './ScanDeviceListItem.module.scss'; 

const MIN_FIRMWARE_VERSION_FOR_PING = "131.5.0";

export const ScanDeviceListItem = ({ device, onSelected, onDeviceUnselected}) => {
    const dispatch = useDispatch();
    const { name, id } = device;

    useDeviceConnectionStatus(id);

    const status = useSelector(getDeviceConnectionStatusById(id));
    const deviceInfo = useSelector(getDeviceInfoById(id));
    const isConnected = status === bleDeviceConnectionStatus.CONNECTED;

    const onConnected = async () => {
        const info = await deviceService.initDevice(id);
        dispatch(setDeviceInfo(id, info));
    }

    useEffect(() => {
        if (deviceInfo?.firmware) {
            const shouldPingDevice = isFirmwareVersionGreaterOrEqual(deviceInfo?.firmware, MIN_FIRMWARE_VERSION_FOR_PING);
            
            if (shouldPingDevice) {
                DevicePingService.startPing(id);
            }
        }

        return () => {
            if (!isConnected) {
                DevicePingService.stopPing(id);
            }
        }
    }, [deviceInfo, isConnected]);

    const onReconnected = async () => {
        if (!deviceInfo) {
            await onConnected();
        }
        await onSelected(id);
    }

    const { connect, disconnect, reconnect, loading } = useDeviceConnection(id, onConnected, onDeviceUnselected, onReconnected);

    const buttonText = isConnected ? "Disconnect" : "Connect";
    const buttonAction = isConnected ? disconnect : connect;

    const deviceItemClassName = cn("flex flex-col w-full justify-between items-center p-4 border", {
        [styles.DeviceItem]: loading
    });

    return (
        <div className={deviceItemClassName}>
            <div className="flex gap-2 flex-col w-full items-start mb-2">
                {name && <div className="text-md">{name}</div>}
                {id && <div className="text-xs">ID: {id}</div>}
            </div>
            <div className="flex w-full justify-between">
                <Button
                    isDisabled={!isConnected || loading}
                    onClick={reconnect}
                >
                    Manage
                </Button>
                <Button
                    isDisabled={loading}
                    // loading={loading}
                    onClick={buttonAction}
                    className="w-32"
                >
                    {/* {!loading && buttonText} */}
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};
